// extracted by mini-css-extract-plugin
module.exports = {"bar":"styles_bar__rVj4B","tabs":"styles_tabs__3RMMS","tab":"styles_tab__1FHeu","active":"styles_active__PYFeF","tabBody":"styles_tabBody__1TAlW"};